import { render, staticRenderFns } from "./notReadNotice.vue?vue&type=template&id=0d7b2978&scoped=true&"
import script from "./notReadNotice.vue?vue&type=script&lang=js&"
export * from "./notReadNotice.vue?vue&type=script&lang=js&"
import style0 from "./notReadNotice.vue?vue&type=style&index=0&id=0d7b2978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7b2978",
  null
  
)

export default component.exports